import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionActions = function QuestionActions(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: React.Children.map(props.actions, function (action) {
      return /*#__PURE__*/_jsx("div", {
        className: styles['action'],
        children: action
      });
    })
  });
};
QuestionActions.displayName = 'QuestionActions';